require([
    'jquery',
	'controller/slider',
    'controller/trigger'
], function ($, slider,trigger) {
	'use strict';
    var sliderelements = $('.slider');

    if (sliderelements.length >=1) {
        sliderelements.each(function(i, element) {
            slider.init(element);
        });
    }
    var menuTrigger = $('.menuTrigger');
    if (menuTrigger.length >= 1) {
        trigger.setMobileMenu($('#navi').find('ul'));
        trigger.init(menuTrigger);

    }
});

define("main", function(){});

